var actionBuilder;
export function registerActionBuilder(externalBuilder) {
    actionBuilder = externalBuilder;
}
export { actionBuilder };
